import { createContext, useContext } from "react";

export const TrayVerificationContext = createContext();

export function useTrayVerificationContext() {
  return useContext(TrayVerificationContext);
}
